import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  listTelefonos: [],
};
export const mutations = {
  GET_TELEFONOS({ context }, result_telefonos) {
    state.loading = false;
    if (result_telefonos) {
      let telefonos = [];
      Object.entries(result_telefonos).forEach(([key, val]) => telefonos.push(val));
      return (state.listTelefonos = telefonos);
    }
  },
  SAVE_TELEFONO({ context }, telefono) {
    state.newTelefono = Object.assign({}, telefono);
  },
};
export const actions = {
  GET_TELEFONOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.get(data)
        .then(response => {
          // console.log(response.data.data);
          commit("SET_LOADING", false);
          commit("GET_TELEFONOS", response.data.data.telefonos);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  SAVE_TELEFONO({ commit }, data) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.post(data)//funcion de ApiService
        .then(response => {
          commit("SET_LOADING", false);
          commit("SAVE_TELEFONO", response);//mandar a mutations
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
  DELETE_TELEFONO({ commit }, id) { //axios, mandar parametros para post
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true);
      ApiService.delete(id)//funcion de ApiService
        .then(response => {
          //console.log("store",response);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch(error => {
          commit("SET_LOADING", false);
          reject(error);
        });
    });
  },
};

export const getters = {
  listTelefonos: state => state.listTelefonos,
};
